export default __webpack_public_path__ + "static/22-f631f65a8c9a12515bf455e4e806c4d8.jpg";